export enum SignatureEnums {
  DIGITAL_SIGNATURE = "digital",
  MANUAL_SIGNATURE = "manual",
}
